import { Component } from "@angular/core";
import { ExportCollectionResultRowComponent } from "./export-collection-result-row.component";
import { LoadingComponent } from "@ponder-shared/loading/loading.component";
import { GetExportUserCollectionResultsResponse, UserCollectionExportTaskStatus } from "@apiserver-rest/ponder-tasks-client-base";
import { PonderTasksClient } from "@apiserver-rest/ponder-tasks-client";
import { Subscription, take } from "rxjs";
import { EventBroker } from "@ponder-core/events/eventBroker";

@Component({
    selector: "export-collection-results",
    imports: [LoadingComponent, ExportCollectionResultRowComponent],
    templateUrl: "./export-collection-results.component.html"
})
export class ExportCollectionResultsComponent {
    public isLoading: boolean = true;
    public loadingSuccess: boolean = false;
    public results?: UserCollectionExportTaskStatus[];

    private collectionExportedSub!: Subscription;

    public constructor(private ponderTasksClient: PonderTasksClient, events: EventBroker) {
        this.collectionExportedSub = events.collection
            .collectionExportedEvent
            .subscribe({
                next: (status: UserCollectionExportTaskStatus) => {
                    if (!this.results) {
                        this.results = [];
                    }

                    this.results.push(status);
                    this.sortResults();
                    this.handlePendingStatusRefresh();
                }
            });
    }

    public ngOnDestroy(): void {
        this.collectionExportedSub.unsubscribe();
    }

    public ngOnInit(): void {
        this.refreshResults();
    }

    private sortResults(): void {
        this.results?.sort((a, b) => b.startedAt.getTime() - a.startedAt.getTime());
    }
    
    /**
     * Pulls the collection export results for the current user.
     */
    private refreshResults(): void {
        this.ponderTasksClient
            .userCollectionExportResults()
            .pipe(take(1))
            .subscribe({
                next: (response: GetExportUserCollectionResultsResponse) => {
                    if (response.success) {
                        this.loadingSuccess = true;
                        this.results = response.results;

                        this.sortResults();
                        this.handlePendingStatusRefresh();
                    }
                }
            })
            .add(() => { this.isLoading = false; });
    }

    /**
     * Checks if any of the collection exports are pending.
     * If so, sets a callback to refresh the results in 5 seconds.
     */
    private handlePendingStatusRefresh(): void {
        if (!this.results?.length) {
            return;
        }
        
        var hasPending: boolean = false;

        for (let i = 0; i < this.results.length; ++i) {
            if (this.results[i].isPending) {
                hasPending = true;
                break;
            }
        }
        
        if (!hasPending) {
            return;
        }

        setTimeout(() => {
            this.refreshResults();
        }, 5000);
    }
}